// extracted by mini-css-extract-plugin
export default {"wrapper":"NYHAYxkWByJBGokWaFEi","profile":"waagn4u9aBNYw2HcmKqA","pic":"toP5JhYWQMfIT9flViaD","rating":"KvqY1vBsQXtj_XSz6W1V","bio":"GjfItPbn4i_Mtom0sTTg"};